import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { useToast } from '../../controller/ToastController';
import StoreController, {
  CurrentStoreContext,
  StoreImageType,
} from '../../controller/StoreController';
import { useOutletContext } from 'react-router-dom';
import AdvertiseController from '../../controller/AdvertiseController';

const AdvertiseUpload = () => {
  const showToast = useToast();
  const [loading, setLoading] = useState<boolean>(false);
  const [storeVideo, setStoreVideo] = useState<StoreImageType>();
  const [storeVideoName, setStoreVideoName] = useState<string>('');
  const [storeImages, setStoreImages] = useState<StoreImageType[]>([]);
  const [videoConfirmStatus, setVideoConfirmStatus] = useState<number>(0);
  const [imageConfirmStatus, setImageConfirmStatus] = useState<any>([]);
  const [videoConfirmDetail, setVideoConfirmDetail] = useState<number>(0);
  const [buttonText, setButtonText] = useState<string>('저장');
  const { currentStore } = useOutletContext<CurrentStoreContext>();
  const [visibleVideoGuide, setVisibleVideoGuide] = useState<boolean>(false);
  const [visibleImageGuide, setVisibleImageGuide] = useState<boolean>(false);

  const [adverType, setAdverType] = useState<number>(0);

  const confirmedReject = imageConfirmStatus.includes(3);
  const changeStatus = imageConfirmStatus.includes(undefined) || videoConfirmStatus === undefined;

  // 비디오 업로드
  const uploadAdvertiseVideo = async (e: any) => {
    try {
      setLoading(true);
      let origin = e.target.files[0];
      if (origin !== undefined) {
        if (origin.type !== undefined && origin.type !== null) {
          if (
            origin.type === 'video/mp4' ||
            origin.type === 'video/webm' ||
            origin.type === 'video/ogg' ||
            origin.type === 'video/x-msvideo' ||
            origin.type === 'video/quicktime'
          ) {
            const formData = new FormData();
            formData.append('file', origin);
            const oRes = await AdvertiseController.storeAdUploadImg(formData, currentStore.value);

            if (oRes.data) {
              const oResponse = oRes.data;

              if (oResponse.ok && oResponse.data) {
                setStoreVideo({
                  adver_media_id: oResponse.data.adver_media_id,
                  url_path: oResponse.data.url_path,
                });
                setStoreVideoName(origin.name);
                setVideoConfirmStatus(0);
              } else {
                showToast('파일 이름이 너무 길거나 형식에 맞지 않아요', 'error');
              }
            }
            return;
          }
        }
      }
    } finally {
      setLoading(false);
    }
  };

  // 사진 업로드
  const uploadAdvertiseImage = async (e: any) => {
    if (storeImages.length < 5) {
      let origin = e.target.files[0];
      if (origin !== undefined) {
        if (origin.type !== undefined && origin.type !== null) {
          if (origin.type === 'image/png' || origin.type === 'image/jpeg') {
            const formData = new FormData();
            formData.append('file', origin);
            const oRes = await AdvertiseController.storeAdUploadImg(formData, currentStore.value);

            if (oRes.data) {
              const oResponse = oRes.data;
              if (oResponse.ok && oResponse.data) {
                storeImages.push({
                  adver_media_id: oResponse.data.adver_media_id,
                  url_path: oResponse.data.url_path,
                });
                setStoreImages([...storeImages]);
              } else {
                showToast('파일 이름이 너무 길거나 형식에 맞지 않아요', 'error');
              }
            }
            return;
          }
        }
      }
    } else {
      showToast('더 이상 사진을 등록할 수 없어요', 'error');
    }
  };

  // 비디오/이비지 삭제
  const deleteImage = (index: number) => {
    storeImages.splice(index, 1);
    setStoreImages([...storeImages]);
  };
  const deleteVideo = () => {
    setStoreVideo(undefined);
    setStoreVideoName('');
    setVideoConfirmStatus(0);
  };

  const RenderGuide = useMemo(() => {
    const maxWidth = 500;
    const guideImage = visibleVideoGuide
      ? window.innerWidth <= maxWidth
        ? `${process.env.PUBLIC_URL}/img/mob_advertise01.png`
        : `${process.env.PUBLIC_URL}/img/advertise01.png`
      : window.innerWidth <= maxWidth
      ? `${process.env.PUBLIC_URL}/img/mob_advertise02.png`
      : `${process.env.PUBLIC_URL}/img/advertise02.png`;
    return (
      <div className={`guideBox ${visibleVideoGuide || visibleImageGuide ? 'active' : ''}`}>
        <img
          src={guideImage}
          alt={visibleVideoGuide ? '동영상 적용 예시 이미지' : '이미지 적용 예시 이미지'}
        />
      </div>
    );
  }, [visibleVideoGuide, visibleImageGuide]);

  // 광고 사진/동영상 정보 가져오기
  const getAdvertise = async () => {
    try {
      const oRes = await AdvertiseController.getAdver(currentStore.value);

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('광고가져오기-->', oResponse);
        if (oResponse.data) {
          if (oResponse.data.video.length > 0) {
            setStoreVideo({
              adver_media_id: oResponse.data.video[0].adver_media_id,
              url_path: oResponse.data.video[0].url_path,
            });
            setStoreVideoName(oResponse.data.video[0].file_name);
            setVideoConfirmStatus(oResponse.data.video[0].confirm_status);
            setVideoConfirmDetail(oResponse.data.video[0].confirm_detail);

            setAdverType(0);
          }
          if (oResponse.data.image.length > 0) {
            let imageListTemp: StoreImageType[] = [];
            oResponse.data.image.map((item: any) => {
              imageListTemp.push({
                adver_media_id: item.adver_media_id,
                url_path: item.url_path,
                confirm_status: item.confirm_status,
                confirm_detail: item.confirm_detail,
              });
            });
            setStoreImages([...imageListTemp]);
            setAdverType(1);

            console.log('imageListTemp', imageListTemp);
          }
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };
  // 광고 등록하기
  const submitAdvertise = async () => {
    try {
      let adverVideoTemp: any[] = [];
      console.log('|| videoConfirmStatus === 3', videoConfirmStatus);
      if (!confirmedReject || videoConfirmStatus !== 3 || !loading) {
        if (adverType === 0 && storeVideo) {
          adverVideoTemp.push({ adver_media_id: storeVideo.adver_media_id });
        }
        let adverImageTemp: any[] = [];
        if (adverType === 1)
          storeImages.map((item: StoreImageType) => {
            adverImageTemp.push({ adver_media_id: item.adver_media_id });
          });

        const oRes = await AdvertiseController.setAdver(
          currentStore.value,
          adverVideoTemp,
          adverImageTemp,
        );

        if (oRes && oRes.data) {
          const oResponse = oRes.data;
          if (oResponse.ok) {
            showToast('광고 검수를 신청했어요.');
          }
        }
      }
      if (confirmedReject || videoConfirmStatus === 3) {
        showToast('반려된 사진/동영상을 삭제해주세요', 'error');
      }
      if (loading) {
        showToast('동영상 업로드중입니다. 잠시만 기다려주세요.', 'error');
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };

  useEffect(() => {
    if (changeStatus) {
      setButtonText('광고 검수 신청하기');
    } else if (confirmedReject || videoConfirmStatus === 3) {
      setButtonText('반려된 동영상/사진을 새로 등록해주세요.');
    } else {
      setButtonText('저장');
    }
  }, [changeStatus, confirmedReject, videoConfirmStatus]);
  useEffect(() => {
    getAdvertise();
  }, [currentStore]);
  useEffect(() => {}, [storeImages, storeVideo, videoConfirmStatus]);
  useEffect(() => {
    setImageConfirmStatus(storeImages.map((image) => image.confirm_status));
  }, [storeImages]);

  return (
    <>
      <Style>
        <div className="contentContainer">
          <div className="selectBoxWrap">
            <div
              className={`selectBox left ${adverType === 0 && 'active'}`}
              onClick={() => setAdverType(0)}>
              동영상
            </div>
            <div
              className={`selectBox right ${adverType === 1 && 'active'}`}
              onClick={() => setAdverType(1)}>
              사진
            </div>
          </div>

          {adverType === 0 ? (
            <div className="inputText">
              <div className="title">
                <h4>동영상 등록</h4>
                <h5>(최대 1개, 총시간은 15초 까지 가능합니다)</h5>
                <div className="guideIcon">
                  <img
                    onMouseEnter={() => setVisibleVideoGuide(true)}
                    onMouseLeave={() => setVisibleVideoGuide(false)}
                    src={`${process.env.PUBLIC_URL}/svg/ic_question.svg`}
                    alt="가이드 아이콘"
                  />
                  {visibleVideoGuide && RenderGuide}
                </div>
              </div>
              <div className="storeInfoWrap">
                <div className="row gap">
                  <div className="videoInput">
                    {storeVideoName === '' ? '동영상을 등록해주세요' : storeVideoName}
                  </div>

                  <label className="imageButton edit">
                    <input
                      type="file"
                      name="video"
                      accept="video/*"
                      onChange={uploadAdvertiseVideo}
                      autoFocus={false}
                    />
                    열기
                  </label>
                  <button className="imageButton delete" onClick={deleteVideo}>
                    삭제
                  </button>
                </div>
                {loading && (
                  <h2 className="loadingText">동영상을 업로드 중입니다. 잠시만 기다려주세요.</h2>
                )}
                <div className="videoConfirmStatus">
                  {videoConfirmStatus === 1 && <h2 className="suceess">검수완료</h2>}
                  {videoConfirmStatus === 2 && <h2 className="progress">검수중</h2>}
                  {videoConfirmStatus === 3 && (
                    <div className="rejectBox">
                      <h2 className="reject">반려됨</h2>
                      <h2 className="rejectText">
                        {videoConfirmDetail === 1 && '* 해상도 문제로 검수가 반려되었습니다.'}
                        {videoConfirmDetail === 2 && '* 정책 부적합으로 검수가 반려되었습니다.'}
                      </h2>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="inputText">
              <div className="title">
                <h4>사진 등록</h4>
                <h5>(최대 5장)</h5>
                <div className="guideIcon">
                  <img
                    onMouseEnter={() => setVisibleImageGuide(true)}
                    onMouseLeave={() => setVisibleImageGuide(false)}
                    src={`${process.env.PUBLIC_URL}/svg/ic_question.svg`}
                    alt="가이드 아이콘"
                  />
                  {visibleImageGuide && RenderGuide}
                </div>
              </div>
              <div className="storeInfoWrap">
                <div className="imageWrap">
                  <label className="photoBox" htmlFor={`storeImage`}>
                    <img
                      src={`${process.env.PUBLIC_URL}/svg/ic_photo.svg`}
                      alt="이미지 추가 아이콘"
                      onClick={() => {
                        if (confirmedReject) {
                          showToast('반려된 사진을 삭제해주세요', 'error');
                        } else if (storeImages.length >= 5) {
                          showToast('최대 5장까지 추가 가능합니다', 'error');
                        }
                      }}
                    />
                    <h5>이미지 추가</h5>
                  </label>
                  <input
                    id={`storeImage`}
                    type="file"
                    name="photo"
                    accept="image/*"
                    autoFocus={false}
                    onChange={uploadAdvertiseImage}
                    disabled={storeImages.length >= 5 || confirmedReject}
                  />
                  <div className="imageList">
                    {storeImages.map((image: StoreImageType, index: number) => {
                      return (
                        <div className="previewImageWrap" key={index}>
                          <div className="imageDeleteButton">
                            <img
                              src={`${process.env.PUBLIC_URL}/svg/ic_close_white.svg`}
                              onClick={() => deleteImage(index)}
                              alt="삭제 아이콘"
                            />
                          </div>
                          <div className="confirmStatus">
                            {image.confirm_status === 1 && <h2 className="suceess">검수완료</h2>}
                            {image.confirm_status === 2 && <h2 className="progress">검수중</h2>}
                            {image.confirm_status === 3 && (
                              <h2 className="reject">
                                {image.confirm_detail === 1 && '해상도 문제'}
                                {image.confirm_detail === 2 && '정책 부적합'}
                              </h2>
                            )}
                          </div>
                          <img className="previewImg" src={image.url_path} alt="none_image" />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          )}
          <button
            className={`submitButton ${
              (confirmedReject || videoConfirmStatus === 3) && 'inactive'
            }`}
            onClick={submitAdvertise}>
            <h2>{buttonText}</h2>
          </button>
          <div className="warningSign">
            <img src={`${process.env.PUBLIC_URL}/svg/ic_warning.svg`} alt="주의사항 아이콘" />
            <p>
              검수 결과, 동영상/이미지의 해상도 문제, 광고정책의 사유로 노출이 제한될 수 있습니다.
              광고는 랜덤으로 진행되며, 노출이 되지 않을수도 있습니다.
            </p>
          </div>
        </div>
      </Style>
    </>
  );
};

export default AdvertiseUpload;

const Style = styled.div`
  .contentContainer {
    border-radius: 10px;
  }

  .inputText {
    padding-bottom: 10%;
    img {
      cursor: pointer;
    }

    .title {
      padding: 20px 0 6px 0;
      display: flex;
      align-items: center;
      gap: 4px;

      h5 {
        color: #40977f;
        font-weight: 500;
      }
      .greyFont {
        color: #a7a7a7;
        font-weight: 400;
      }
      h4 {
        color: #555555;
      }
    }
    .title.initial {
      padding: 0 0 6px 0;
    }
  }

  .infoBadge {
    background: #ecf5f3;
    border-radius: 5px;
    display: flex;
    align-items: center;
    padding: 8px 20px;
    gap: 12px;
    h4 {
      color: #555555;
    }
  }

  .row.gap {
    display: flex;
    align-items: center;
    gap: 6px;
    .videoInput {
      width: 100%;
      padding: 6px 18px;
      border: 1px solid #cecece;
      border-radius: 5px;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      color: #a7a7a7;
      text-align: left;
      background: #ffffff;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    .imageButton {
      background: #ffffff;
      text-align: center;
      border-radius: 5px;
      padding: 6px 14px;
      font-size: 14px;
      line-height: 20px;
      font-weight: 500;
      white-space: nowrap;
      cursor: pointer;
    }
    .imageButton.edit {
      border: 1px solid #cecece;
      color: #555555;
    }
    .imageButton.delete {
      border: 1px solid #4dd2ae;
      color: #4dd2ae;
    }
  }
  /* 비디오 */
  .videoConfirmStatus {
    margin-top: 8px;
  }
  .suceess,
  .progress,
  .reject {
    padding: 6px 16px;
    color: #fff;
    border-radius: 5px;
    font-size: 16px;
    font-weight: 600;
    background: #a7a7a7;
    display: inline-block;
  }
  .suceess {
    background: #4dd2ae;
  }
  .rejectBox {
    display: flex;
    align-items: center;

    .reject {
      background: #ff6060;
    }
    .rejectText {
      margin-left: 6px;
      font-size: 14px;
      font-weight: 500;
      color: #ff6060;
    }
  }

  .imageList {
    display: flex;
    align-items: center;
    gap: 8px;
    overflow-x: auto;
    padding: 12px 0;

    .row.between {
      align-items: flex-start;
    }
    .previewImageWrap {
      width: 120px;
      height: 120px;
      position: relative;
      .imageDeleteButton {
        position: absolute;
        top: 0;
        right: 0;
        width: 24px;
        height: 24px;
        border-radius: 0 5px 0 5px;
        background: rgba(0, 0, 0, 0.3);
      }
      .confirmStatus {
        position: absolute;
        bottom: 0;
        left: 0;

        h2 {
          padding: 4px 10px;
          border-radius: 0 4px 0 4px;
          font-size: 14px;
          font-weight: 600;
          color: #fff;
        }
        .suceess,
        .progress {
          background: #a7a7a7;
        }
        .suceess {
          background: #4dd2ae;
        }
        .reject {
          background: #ff6060;
        }
      }
    }
    .previewImageWrap.logo {
      height: 102px;
    }

    .previewImg {
      width: 100%;
      height: 100%;
      border-radius: 5px;
      object-fit: cover;
    }
  }
  .loadingText {
    font-size: 14px;
    font-weight: 400;
    margin-top: 4px;
  }
  .photoBox {
    width: 120px;
    height: 120px;
    border-radius: 5px;
    padding: 10px;
    padding-top: 20px;
    border: 1px solid #cecece;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 6px;
    cursor: pointer;

    h5 {
      color: #a7a7a7;
      font-weight: 400;
    }
  }

  /* 저장버튼 */
  .submitButton {
    margin-top: 27px;
    h2 {
      font-size: 20px;
    }
  }
  .warningSign {
    margin-top: 13px;

    p {
      font-size: 14px;
      font-weight: 500;
      color: #979797;
      line-height: 19px;
      word-break: keep-all;
    }
  }

  input[type='file'] {
    display: none;
  }

  .guideIcon {
    display: inline-flex;
    position: relative;
  }
  .guideBox {
    position: absolute;
    min-width: 400px;
    top: -4px;
    left: 16px;
    opacity: 0;
    z-index: 2;

    img {
      width: 100%;
    }
  }
  .guideBox.active {
    animation: fadeIn 0.2s ease-in-out forwards;
  }

  @media (max-width: 600px) {
    .imageList {
      flex-wrap: wrap;
      gap: 0.5%;

      .previewImageWrap {
        width: 33%;
        margin-bottom: 1%;
      }
    }
    .guideBox {
      min-width: 240px;
      top: 20px;
      left: -50px;
      opacity: 0;
      z-index: 2;

      img {
        width: 100%;
      }
    }
    .submitButton {
      h2 {
        font-size: 16px;
      }
    }
  }

  .selectBoxWrap {
    display: flex;
    align-items: center;
    padding: 30px 0;

    .selectBox {
      flex: 1;
      border: 1px solid #cecece;
      background: #f7f7f7;
      font-size: 14px;
      line-height: 20px;
      color: #555555;
      padding: 8px 0;
      text-align: center;
      cursor: pointer;
    }
    .selectBox.left {
      border-radius: 5px 0px 0px 5px;
      border-right: none;
    }
    .selectBox.right {
      border-radius: 0px 5px 5px 0px;
      border-left: none;
    }
    .selectBox.active {
      border: 1px solid #4dd2ae;
      background: #ecf5f3;
      color: #40977f;
    }
  }
`;
